import { Link } from "react-router-dom";

const LOGO = "https://customer-assets.emergentagent.com/job_culinary-connect-37/artifacts/dowryrls_582627c1-c0bf-47f6-ab36-5cc8b78702e3.png";

export default function Footer() {
  return (
    <footer className="bg-[#050505] border-t border-[#D4AF37]/15 py-16 mt-auto">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={LOGO} alt="Are You A Chef" className="h-12 w-12 rounded-full object-cover" />
              <span className="font-serif text-white text-xl">
                Are You A Chef<span className="text-[#D4AF37]">.</span>com
              </span>
            </div>
            <p className="text-[#A0A0A0] text-sm leading-relaxed">
              The UK&apos;s premier directory for private chef services. Connecting exceptional culinary talent with discerning clients.
            </p>
          </div>

          {/* Links */}
          <div>
            <p className="text-xs tracking-[0.2em] uppercase text-[#D4AF37] mb-4">Explore</p>
            <div className="flex flex-col gap-3">
              <Link to="/find-a-chef" className="text-[#A0A0A0] hover:text-white text-sm transition-colors">Find a Chef</Link>
              <Link to="/register?role=chef" className="text-[#A0A0A0] hover:text-white text-sm transition-colors">List Your Services</Link>
              <Link to="/register" className="text-[#A0A0A0] hover:text-white text-sm transition-colors">Create Account</Link>
            </div>
          </div>

          {/* Info */}
          <div>
            <p className="text-xs tracking-[0.2em] uppercase text-[#D4AF37] mb-4">Information</p>
            <div className="flex flex-col gap-3">
              <span className="text-[#A0A0A0] text-sm">Secure payments by</span>
              <div className="flex items-center gap-2">
                <div className="border border-[#D4AF37]/30 px-3 py-1">
                  <span className="text-[#D4AF37] text-sm font-medium tracking-wide">STRIPE</span>
                </div>
              </div>
              <p className="text-[#A0A0A0] text-xs mt-2">£40 per quarter to list your chef services</p>
            </div>
          </div>
        </div>

        <div className="border-t border-[#D4AF37]/10 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-[#555] text-xs">&copy; 2026 Are You A Chef .com. All rights reserved.</p>
          <p className="text-[#555] text-xs">Est. 2026 &bull; United Kingdom</p>
        </div>
      </div>
    </footer>
  );
}
